
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UsersSelect from "@/components/autocompleteMultiselects/UsersSelect.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";

  import { User } from "@/generated/graphql";

  @Component({
    components: {
      UsersSelect,
      UiButton,
      ModalFullScreen,
    },
  })
  export default class CreateConversationModal extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly value!: boolean;

    user: User | null = null;

    handleClose(): void {
      this.$emit("input", false);
      this.user = null;
    }

    sendMessage(): void {
      this.$emit("createConversation", this.user?.id);
      this.handleClose();
    }
  }
